export { CatalogProductFooter } from './libs/components/CatalogProductFooter';
export { Footer } from './libs/components/Footer';
